import http from "@/utils/request";

const category = {
  list: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderCategoryService.queryAllCategoryList",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
  queryAllCategories: (data) =>
    http.sendRequest({
      METHOD_NAME: "venderCategoryService.queryAllCategories",
      SECURITY_TYPE: "UserLogin",
      data,
      ERROR_CODE: {},
    }),
};

export default category;
